import "core-js/modules/es7.array.includes";
import "core-js/modules/es6.string.includes";
import "core-js/modules/es6.function.bind";
import _classCallCheck from "/Users/oleksiim/projects/wix/playable/node_modules/okidoc-site/site/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/Users/oleksiim/projects/wix/playable/node_modules/okidoc-site/site/node_modules/@babel/runtime/helpers/esm/createClass";
import _possibleConstructorReturn from "/Users/oleksiim/projects/wix/playable/node_modules/okidoc-site/site/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/Users/oleksiim/projects/wix/playable/node_modules/okidoc-site/site/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";
import _assertThisInitialized from "/Users/oleksiim/projects/wix/playable/node_modules/okidoc-site/site/node_modules/@babel/runtime/helpers/esm/assertThisInitialized";
import _inherits from "/Users/oleksiim/projects/wix/playable/node_modules/okidoc-site/site/node_modules/@babel/runtime/helpers/esm/inherits";
import "core-js/modules/es6.object.define-property";

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

import React, { Component, Fragment } from 'react';
import PropTypes from 'prop-types';
import DemoModal from './DemoModal';
import getClosestAnchor from './getClosestAnchor';

var CatchDemoLinks =
/*#__PURE__*/
function (_Component) {
  _inherits(CatchDemoLinks, _Component);

  function CatchDemoLinks(props) {
    var _this;

    _classCallCheck(this, CatchDemoLinks);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(CatchDemoLinks).call(this, props));
    _this.state = {
      isModalOpen: false,
      modalSrc: ''
    };
    _this.onNodeClick = _this.onNodeClick.bind(_assertThisInitialized(_this));
    _this.onCloseDemoModal = _this.onCloseDemoModal.bind(_assertThisInitialized(_this));
    return _this;
  }

  _createClass(CatchDemoLinks, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      this.node.addEventListener('click', this.onNodeClick);
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      this.node.removeEventListener('click', this.onNodeClick);
    }
  }, {
    key: "onNodeClick",
    value: function onNodeClick(e) {
      if (e.button !== 0 || e.altKey || e.ctrlKey || e.metaKey || e.shiftKey || e.defaultPrevented) {
        return;
      }

      var anchor = getClosestAnchor(e.target, this.node);

      if (!anchor || !anchor.href) {
        return;
      }

      if (anchor.href.includes('jsfiddle')) {
        e.preventDefault();
        this.onOpenDemoModal(anchor.href + 'embedded/result,js/dark/');
      }
    }
  }, {
    key: "onOpenDemoModal",
    value: function onOpenDemoModal(href) {
      this.setState({
        isModalOpen: true,
        modalSrc: href
      });
    }
  }, {
    key: "onCloseDemoModal",
    value: function onCloseDemoModal() {
      this.setState({
        isModalOpen: false,
        modalSrc: ''
      });
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;

      var _this$state = this.state,
          isModalOpen = _this$state.isModalOpen,
          modalSrc = _this$state.modalSrc;
      var child = React.Children.only(this.props.children);
      return React.createElement(Fragment, null, React.cloneElement(child, {
        ref: function ref(node) {
          _this2.node = node; // Call the original ref, if any

          if (typeof child.ref === 'function') {
            child.ref(node);
          }
        }
      }), React.createElement(DemoModal, {
        isOpen: isModalOpen,
        src: modalSrc,
        onRequestClose: this.onCloseDemoModal
      }));
    }
  }]);

  return CatchDemoLinks;
}(Component);

_defineProperty(CatchDemoLinks, "propTypes", {
  children: PropTypes.node.isRequired
});

export default CatchDemoLinks;